import { Component } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { compose } from '@ngrx/store';
import { FirebaseService } from './services/firebase.service';

@Component({
  selector: 'uo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'uOrder';
  version = false;
  private touchStartSubscription!: Subscription;
  private touchEndSubscription!: Subscription;

  constructor(private firebaseService: FirebaseService) {
    // Track app visit - only once when app loads
    this.trackAppVisit();
    // Google Maps API loading removed - now using backend proxy to protect API key
    this.doubleClick();
   // this.startWorker();
  }

  /**
   * Track customer visit to uOrder app
   * This runs once when the app initializes
   */
  private trackAppVisit(): void {
    // Try multiple times with increasing delays to ensure Analytics is ready
    const tryLogEvent = (attempt: number = 1) => {
      if (this.firebaseService.isAnalyticsReady()) {
        this.firebaseService.logEvent('uorder_visit', {
          app_name: 'uOrder',
          visit_timestamp: new Date().toISOString()
        });
      } else {
        if (attempt < 5) {
          setTimeout(() => tryLogEvent(attempt + 1), 500 * attempt);
        }
      }
    };
    
    // Start trying after initial delay
    setTimeout(() => tryLogEvent(), 1000);
  }
  startWorker() {
    try {
      const worker = new Worker('./assets/js/worker.js');
      const version = localStorage.getItem('VERSION') || '';
      worker.onmessage = (event) => {
        this.version = true;
        this.update();
      };
      worker.postMessage(version);
    } catch (e) {
      console.log('worker:', e);
    }
  }
  private doubleClick(): void {
    this.touchStartSubscription && this.touchStartSubscription.unsubscribe();
    this.touchEndSubscription && this.touchEndSubscription.unsubscribe();
    let lastTouch = 0;
    this.touchStartSubscription = fromEvent(window, 'touchstart').subscribe(
      (event) => {
        if ((event as TouchEvent).touches.length > 1) {
          event.preventDefault();
        }
      }
    );
    this.touchEndSubscription = fromEvent(window, 'touchend').subscribe(
      (event) => {
        const now = new Date().getTime();
        if (now - lastTouch <= 300) {
          event.preventDefault();
          lastTouch = now;
        }
      }
    );
  }
  update() {
    // location.href = "/";
  }
}
